import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { S } from "./ibloom/styles";

/**
 * Crawlable public directory of every shop & product on Mapbazar.
 *
 * The map is JavaScript-only and therefore invisible to crawlers — this page
 * gives Google (and the build-time prerenderer) a plain, link-rich HTML index
 * so every /shop/{slug} and /product/{slug} page is discoverable and indexed.
 * Uses real <a href> anchors (not router buttons) so crawlers follow them.
 */
export default function Directory() {
  const [dir, setDir] = useState({ shops: [], products: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/seo/directory")
      .then((r) => setDir(r.data || { shops: [], products: [] }))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 820, margin: "0 auto", minHeight: "100dvh", background: "#FAFAF5", padding: "24px 18px 48px" }} data-testid="directory-page">
      <a href="/" style={{ display: "inline-flex", alignItems: "center", textDecoration: "none", marginBottom: 18 }}>
        <img src="/mapbazar-logo.png" alt="Mapbazar" style={{ height: 28 }} />
      </a>
      <h1 style={{ ...S.fraunces, fontSize: 26, fontWeight: 800, color: "#1A1A1A", margin: "8px 0 4px" }}>
        Mapbazar Directory — Shops &amp; Products in Ahmedabad
      </h1>
      <p style={{ fontSize: 13.5, color: "#666", lineHeight: 1.6, marginBottom: 24 }}>
        Browse every local shop and product listed on Mapbazar. See real in-store stock, order from
        home with same-day local delivery, and earn free BP &amp; sugar health checkups with every order.
      </p>

      {loading ? (
        <div style={{ color: "#888", fontSize: 13 }}>Loading directory…</div>
      ) : (
        <>
          <section style={{ marginBottom: 32 }}>
            <h2 style={{ fontSize: 16, fontWeight: 800, color: "#0F3D2E", marginBottom: 10 }} data-testid="directory-shops-heading">
              Shops ({dir.shops?.length || 0})
            </h2>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 8 }}>
              {(dir.shops || []).map((s) => (
                <li key={s.slug}>
                  <a href={s.path || `/shop/${s.slug}`} data-testid={`directory-shop-${s.slug}`}
                    style={{ display: "block", padding: "10px 12px", background: "white", border: "1px solid #EAE8DC", borderRadius: 10, color: "#0F3D2E", textDecoration: "none", fontWeight: 700, fontSize: 13.5 }}>
                    🏬 {s.name}{s.city ? <span style={{ color: "#888", fontWeight: 500 }}>, {s.city}</span> : null}
                  </a>
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h2 style={{ fontSize: 16, fontWeight: 800, color: "#0F3D2E", marginBottom: 10 }} data-testid="directory-products-heading">
              Products ({dir.products?.length || 0})
            </h2>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))", gap: 8 }}>
              {(dir.products || []).map((p) => (
                <li key={p.slug}>
                  <a href={p.path || `/product/${p.slug}`} data-testid={`directory-product-${p.slug}`}
                    style={{ display: "block", padding: "10px 12px", background: "white", border: "1px solid #EAE8DC", borderRadius: 10, color: "#1A1A1A", textDecoration: "none", fontSize: 13 }}>
                    <span style={{ fontWeight: 700 }}>{p.name}</span>
                    <span style={{ color: "#0F3D2E", fontWeight: 800 }}> — ₹{p.price}</span>
                    {p.shop_name ? <span style={{ color: "#888" }}> at {p.shop_name}</span> : null}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        </>
      )}
    </div>
  );
}
